export const SkeletonBox = ({ width = "100%", height = "38px", mode, style = {} }) => (
  <div
    style={{
      width,
      height,
      borderRadius: "6px",
      background: mode
        ? "linear-gradient(90deg, #2C2E33 25%, #3a3c42 37%, #2C2E33 63%)"
        : "linear-gradient(90deg, #eee 25%, #f5f5f5 37%, #eee 63%)",
      backgroundSize: "400% 100%",
      animation: "skeleton-shimmer 1.4s ease-in-out infinite",
      ...style,
    }}
  />
);
